import axios from 'axios'

const client = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
})

// Rails CSRF: el token se expone en un <meta name="csrf-token"> del layout.
client.interceptors.request.use((config) => {
  const token = document.querySelector('meta[name="csrf-token"]')?.content
  if (token) config.headers['X-CSRF-Token'] = token
  return config
})

export default client
